import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UiService {
  constructor(private dialog: MatDialog, private snackBar: MatSnackBar) {}

  // Open a Material Dialog
  openDialog(component: any, config: any = {}, data: any = {}) {
    const isMobile = window.innerWidth < 768; // Adjust breakpoint as needed
    
    // Default configuration
    const defaultConfig = {
      width: isMobile ? '100%' : 'auto', // Full width on mobile, auto on desktop
      height: isMobile ? 'auto' : 'auto', // Full height on mobile, auto on desktop
      maxWidth: '100vw', // Prevent horizontal overflow
      maxHeight: '100vh', // Prevent vertical overflow
      panelClass: isMobile ? 'full-screen-dialog' : '', // Optional: Add custom class for mobile
      data,
      ...config, // Allow custom config to override defaults
    };
  
    return this.dialog.open(component, defaultConfig);
  }

  // Open a Snackbar (Toaster)
  openSnackBar(message: string, action: string = 'OK', duration: number = 3000) {
    return this.snackBar.open(message, action, { duration });
  }

  // Close all open dialogs
  closeAllDialogs() {
    this.dialog.closeAll();
  }

  ///////////////////////////////////////////////////////  toaster

  showToast(message: string, action: string = 'Close', duration: number = 3000) {
    this.snackBar.open(message, action, {
      duration,
      horizontalPosition: 'center', // 'start' | 'center' | 'end' | 'left' | 'right'
      verticalPosition: 'top', // 'top' | 'bottom'
    });
  }

  /////////////////////////////////////////  Spinner 

  private isLoadingSubject = new BehaviorSubject<boolean>(false);
  isLoading$ = this.isLoadingSubject.asObservable();

  showSpinner() {
    this.isLoadingSubject.next(true);
  }

  hideSpinner() {
    this.isLoadingSubject.next(false);
  }

}
